import { render, staticRenderFns } from "./MessagePopup.vue?vue&type=template&id=d3d22982"
import script from "./MessagePopup.vue?vue&type=script&lang=js"
export * from "./MessagePopup.vue?vue&type=script&lang=js"
import style0 from "./MessagePopup.vue?vue&type=style&index=0&id=d3d22982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports